import Typograf from "typograf";

export const tp = new Typograf({
  locale: ["ru", "en-US"]
});
